<template>
  <div :class="fieldClass">
    <label v-if="label" :for="id" class="form-label" :class="labelClass">{{ label }}</label>
    <slot />
    <div v-if="errorMessage" class="invalid-feedback">{{ errorMessage }}</div>
    <div v-if="note" class="small text-muted mt-1" :class="{ 'text-break': breakNote }">{{
      note
    }}</div>
  </div>
</template>

<script lang="ts" setup>
defineOptions({
  inheritAttrs: false,
})

defineProps({
  id: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    default: '',
  },
  note: {
    type: String,
    default: '',
  },
  errorMessage: {
    type: String,
    default: '',
  },
  fieldClass: {
    type: String,
    default: '',
  },
  labelClass: {
    type: String,
    default: '',
  },
  breakNote: {
    type: Boolean,
    default: false,
  },
})
</script>
